<template>
  <div class="container-fluid">
    <h4 class="m-3">Изменение раздела</h4>
    <el-form ref="form"
      :model="section"
      label-position="left"
      label-width="220px"
      id="uploadForm"
      name="uploadForm">
      <el-form-item label="Название">
        <el-input v-model="section.title" disabled></el-input>
      </el-form-item>
      <el-form-item label="Ссылка">
        <el-input  v-model="section.slug" disabled></el-input>
      </el-form-item>
      <el-form-item  label="Родительский раздел">
        <el-input  v-model="section.parent_id" disabled></el-input>
      </el-form-item>

      <el-form-item label="Сортировка">
        <el-input v-model="query.sort"></el-input>
      </el-form-item>

      <el-form-item  label="Показывать на главной">
        <el-checkbox v-model="query.showOnMain"></el-checkbox>
      </el-form-item>

      <el-form-item label="Активность">
          <el-checkbox v-model="query.activity"></el-checkbox>
      </el-form-item>

      <el-form-item label="Изображение">
        <el-upload
        action=""
        list-type="picture"
        :file-list="listImages"
        :limit="1"
        :auto-upload="false"
        :on-change="(v) => handleChange(typesImage.main, v)"
        >
          <el-button size="small" type="primary">Добавить Изображение</el-button>
        </el-upload>
      </el-form-item>

      <el-form-item label="Мобильное изображение">
        <el-upload
        action=""
        list-type="picture"
        :file-list="listMobileImages"
        :limit="1"
        :auto-upload="false"
        :on-change="(v) => handleChange(typesImage.mobile, v)"
        >
          <el-button size="small" type="primary">Добавить Изображение</el-button>
        </el-upload>
      </el-form-item>

      <el-form-item label="Иконка">
        <el-row>
          <el-col :span="12">
            <el-select   
            v-model="query.iconId"             
            placeholder="Выберите иконку"
            :style="{width: '100%', maxWidht: '100%'}"
            >
              <el-option
              v-for="it in getIcons"
              :key="it.id"
              :value="it.id"
              :label="it.alt || it.id"    
              >
              <el-row>
                <el-col :span="3"><el-image style="width: 34px; height: 34px" :src="it.path" fit="cover" /></el-col>
                <el-col :span="4"><span>{{it.alt || it.id}}</span></el-col>
              </el-row>                    
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-button @click="$store.commit('iconDialog',true)">Добавить иконку</el-button>
          </el-col>
        </el-row>
       
      </el-form-item>

        <h5>Текстовая область</h5>
        <el-form-item label="Изображение">
          <el-upload
          action=""
          list-type="picture"
          :file-list="listSeoImages"
          :limit="1"
          :auto-upload="false"
          :on-change="(v) => handleChange(typesImage.seo, v)"
          >
            <el-button size="small" type="primary">Добавить Изображение</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="SEO-текст">
          <!-- <ckeditor v-model="query.seoText" /> -->
            <el-input
            v-model="query.seoText"
            type="textarea"
            :autosize="{ minRows: 6, maxRows: 8 }"
            placeholder=""
          />
        </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="updateSection()">Изменить</el-button>
        <el-button @click="back">Отмена</el-button>
      </el-form-item>
    </el-form>
    <icon-dialog ></icon-dialog >

  </div>
</template>

<script>
import axios from "axios";

import getErrors, { getTextErrors } from '../../composable/utils/getErrors';
import getFileList from '../../composable/utils/getFileList';
import useFormData from '../../composable/useFormData';
import IconDialog from '@/components/Icon/AddIconDialog';


export default {
  components: { IconDialog },
  data: function (){
    return {
      typesImage: {
        seo: 'seo',
        mobile: 'mobile',
        main: 'main',        
      },
      query: {
        id: 0,
        showOnMain: false,
        image: '',
        mobileImage: '',        
        iconId: '',
        seoImage: '',
        seoText: '',
        activity: false,
        sort: 0,
      },
      errors: [],
      section:{},
      sections:[],

      listImages: [],
      listSeoImages: [],
      listIcons: [],
      listMobileImages: []
    }
  },
  computed: {
    getIcons() {
        return this.$store.state.IconDialog.generalIcons
    },
  },
  mounted() {
    this.getSection();
  },
  methods:{
    back(){
      this.$router.go(-1);
    },
    updateSection(){
      const { execute } = useFormData()

      const data = execute().setFields([
        'showOnMain',
        'image',
        'mobileImage',
        'iconId',
        'seoImage',
        'seoText',
        'activity',
        'sort',
      ]).getFormData(this.query)

      const id = this.$route.params.id;

      axios.post(`/catalog/section/${id}`, data)
      .then((response)=>{
        this.status = response.status;
        this.back()
      })
      .catch((errors) => {
        if(errors.response.status === 422) {
          this.setErrors(errors.response.data.errors)
          this.$notify.error(getTextErrors(this.errors))
        }
        if(errors.response.status === 401){          
          this.$router.push('/login');
        }
      });
    },

    handleChange(typeImage, value) {
      const file = value?.raw || undefined;
      if (typeImage === this.typesImage.seo) {
        this.query.seoImage = file;
      } else if (typeImage === this.typesImage.mobile) {
        this.query.mobileImage = file;
      } else if (typeImage === this.typesImage.main) {
        this.query.image = file;
      } 
    },

    getSection: function (){
      const id = this.$route.params.id;
      axios.get(`/catalog/section/${id}`)
      .then((response)=>{
        this.initValues(response.data)
      })
      .catch(() => {})
    },

    setErrors(err) {
      this.errors = getErrors(err)
    },

    setSection(value) {
      this.section = value
    },

    setListImg (typeImage, value) {
      if (typeImage === this.typesImage.seo) {
        this.listSeoImages = getFileList(value)
      } else if (typeImage === this.typesImage.mobile) {
        this.listMobileImages = getFileList(value)
      } else if (typeImage === this.typesImage.main) {
        this.listImages = getFileList(value)
      } else if (typeImage === this.typesImage.icon) {
        this.listIcons = getFileList(value)
      }
    },

    setQuery(value) {
        this.query.id = value.id
        this.query.showOnMain = value.show_on_main || false;
        this.query.seoText = value.seo_text || '';
        this.query.activity = value.activity || false;
        this.query.sort = value.sort || 0;
        this.query.iconId = value.icon_id || '';
    },

    initValues(value) {
      if (value) {
        this.setQuery(value)
        this.setSection(value)
        this.setListImg(this.typesImage.seo, value.seo_image)
        this.setListImg(this.typesImage.mobile, value.mobile_image)
        this.setListImg(this.typesImage.main, value.image)        
      }
    }
  }
}
</script>

<style scoped>

</style>